// extracted by mini-css-extract-plugin
export default {"List":"List_List__UXzOB","Small":"List_Small__ewuQO","Big":"List_Big__SeC1-"};